import { Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { GridOptions } from 'ag-grid';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { IMyOptions } from 'mydatepicker';
import { Subscription } from 'rxjs/Subscription';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-on-demand-drivers-trip-history',
  templateUrl: './trip-history.component.html',
  styleUrls: ['./trip-history.component.scss']
})
export class TripHistoryComponent implements OnInit, OnChanges, OnDestroy {

  private subcrip: Subscription[];
  private historyGrid: GridOptions;
  private totalRows = 0;
  protected dateRangeExport: any;
  protected selectedDate: any;
  protected date: any;

  @Input() selected: number;
  @Input() startDate: string;
  @Input() endDate: string;

  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();

  constructor(
    protected service: OnDemandDriversService,
    private sweetAlertHelper: SweetAlertHelper
  ) {
    this.subcrip = [];
    this.historyGrid = < GridOptions > {};
    this.configureGrid();
  }

  /**
   * @name ngOnInit
   * @description
   */
  ngOnInit() {
    const self = this;
    this.historyGrid.onGridReady = function () {
      self.historyGrid.api.sizeColumnsToFit();
      self.retrieveData();
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      if (this.historyGrid && this.historyGrid.api) {
        this.historyGrid.api.setRowData([]);
      }
      this.retrieveData();
    }
  }

  ngOnDestroy(): void {
    if (this.subcrip.length) {
      this.subcrip.forEach((sub: Subscription) => {
        sub.unsubscribe();
      });
    }
  }

  /**
   * @name cancelCreateEdit
   * @description
   */
  public cancelCreateEdit() {
    this.cancel.emit(true);
  }


  /**
   * @name changeFilter
   * @description
   */
  private changeFilter() {
    let count = 0;
    this.historyGrid.api.forEachNodeAfterFilter((node) => {
      count = count + 1;
    });
    this.totalRows = count;
  }

  private retrieveData() {
    const getTrip$ = this.service
      .getTripHistory(this.selected)
      .subscribe(
        data => {
          if (this.historyGrid) {
            if (this.historyGrid.api) {
              this.historyGrid.api.setRowData(data);
            }
          }
        },
        (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      );
    this.subcrip.push(getTrip$);
  }

  /**
   * @name configureGrid
   * @description
   */

  private amountCell = (params: any) => {
    return _currencyFormat(params.value ? params.value : 0);
  }

  private configureGrid() {

    this.historyGrid.columnDefs = [{
        headerName: 'Reservation',
        field: 'reservationnumber',
        colId: 'reservationnumber',
        width: 120
      },
      {
        headerName: 'DOS',
        field: 'dos',
        colId: 'dos',
        width: 120
      },
      {
        headerName: 'Vehicle',
        field: 'vehicle',
        colId: 'vehicle',
        width: 120
      },
      {
        headerName: 'Status',
        field: 'status',
        colId: 'status',
        width: 120
      },
      {
        headerName: 'Rider',
        field: 'rider',
        colId: 'rider'
      },
      {
        headerName: 'Pick Up',
        field: 'pickup',
        colId: 'pickup'
      },
      {
        headerName: 'Mileage',
        field: 'mileage',
        colId: 'mileage',
        width: 70
      },
      {
        headerName: 'Fare',
        field: 'amount',
        colId: 'amount',
        width: 90,
        cellStyle: { textAlign: 'right' },
        cellRenderer: this.amountCell
      },
      {
        headerName: 'Paid',
        field: 'paid',
        colId: 'paid',
        cellRendererFramework: BooleanCheckComponent,
        width: 55
      }
    ];
  }

  // tslint:disable-next-line:member-ordering
  public myRDPOptions: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: false,
  };

  datesSelected(event) {
    event.type === 1 ? this.startDate = event.formatted : this.endDate = event.formatted;
    this.date = event;
  }

 getTrips() {
   const tripHistori$ = this.service
     .getTripHistoryDateRange(this.selected, this.startDate, this.endDate)
     .subscribe(
       data => {
         if (this.historyGrid) {
           if (this.historyGrid.api) {
             this.historyGrid.api.setRowData(data);
           }
         }
       }
     );
   this.subcrip.push(tripHistori$);
   }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/trip-history/trip-history.component.ts